import { render } from "./topbar.vue?vue&type=template&id=41452dec&ts=true"
import script from "./topbar.vue?vue&type=script&lang=ts"
export * from "./topbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__